import {customAxiosBE} from "../config";
import {parsePaginationParams} from "../../utils/other";
import {getSessionOperator} from "../../helper/session";

/**
 * Identitet PIN-ulogovanog radnika postoji samo na klijentu (token je stanični nalog),
 * pa se uz svaku izmenu dnevnika šalje da bi backend upisao ko je akciju uradio.
 */
function withDispatcher(payload) {
    const operator = getSessionOperator();
    return {
        ...payload,
        dispatcherUid: operator?.uid || null,
        dispatcherName: operator?.username || null,
    };
}

export async function insertTrafficLogAPI(payload) {
    return customAxiosBE.post(`/trafficLog`, withDispatcher(payload))
}

export async function insertOtherTrafficLogAPI(payload) {
    return customAxiosBE.post(`/trafficLog/other`, withDispatcher(payload))
}

export async function updateOtherTrafficLogAPI(payload) {
    return customAxiosBE.put(`/trafficLog/other`, withDispatcher(payload))
}

export async function insertOrUpdateTrafficLogAPI(payload) {
    return customAxiosBE.post(`/trafficLog/insertOrUpdate`, withDispatcher(payload))
}

export async function updateTrafficLogAPI(payload) {
    return customAxiosBE.put(`/trafficLog`, withDispatcher(payload))
}

export async function searchTripWithTrafficLogApi(data) {
    return customAxiosBE.post(`/trafficLog/getAllDepAndArr`, data)
}

export async function setIssuedTrafficLogAPI(id) {
    return customAxiosBE.patch(`/trafficLog/issued/${id}`)
}

export async function searchTrafficLogsApi(data) {
    return customAxiosBE.post(`/trafficLog/search`, data)
}

export async function searchOtherTrafficLogsApi(data) {
    const parsedParams = parsePaginationParams(data)
    return customAxiosBE.get(`/trafficLog/other?${parsedParams}${data.search}`)
}

export async function finishTrafficLogParkingApi(data) {
    return customAxiosBE.post(`/trafficLog/finish-parking`, withDispatcher(data))
}

export async function startTrafficLogParkingApi(data) {
    return customAxiosBE.post(`/trafficLog/start-parking`, withDispatcher(data))
}

export async function getTrafficLogsForFiscalisationAPI(){
    return customAxiosBE.get(`/trafficLog/fiscalization`)
}

export async function getOpenTrafficLog(arrVehiclePlate, depVehiclePlate) {
    if(arrVehiclePlate && arrVehiclePlate?.trim() !== ""){
        return customAxiosBE.get(`/trafficLog/open?arrVehiclePlate=${arrVehiclePlate}`)
    }
    return customAxiosBE.get(`/trafficLog/open?depVehiclePlate=${depVehiclePlate}`)
}

export async function deleteTrafficLogAPI(id) {
    const {dispatcherUid, dispatcherName} = withDispatcher({});
    const params = new URLSearchParams();
    if (dispatcherUid) {
        params.append("dispatcherUid", dispatcherUid);
    }
    if (dispatcherName) {
        params.append("dispatcherName", dispatcherName);
    }
    const query = params.toString();
    return customAxiosBE.delete(`/trafficLog/${id}${query ? `?${query}` : ""}`)
}

export async function searchTrafficLogActionsAPI(filter, params) {
    const parsedParams = parsePaginationParams(params)
    return customAxiosBE.post(`/trafficLog/actions/search?${parsedParams}`, filter)
}

export async function getAllOpenParkingAPI(operatorId, plate, params) {
    let searchParams = "";
    if(operatorId){
        searchParams += `operator=${operatorId}&`
    }
    if(plate){
        if(operatorId){
            searchParams+="&"
        }
        searchParams += `plate=${plate}&`
    }
    const parsedParams = parsePaginationParams(params)
    return customAxiosBE.get(`/trafficLog/open-parking?${searchParams}${parsedParams}`)
}

export async function deleteOpenParkingAPI(trafficId){
    return customAxiosBE.delete(`/trafficLog/open-parking/${trafficId}`)
}

export async function editOpenParkingAPI(payload){
    return customAxiosBE.patch(`/trafficLog/open-parking`, withDispatcher(payload))
}

export async function getTrafficLogByTripId(data) {
    return customAxiosBE.get(`/trafficLog/tripId`, { params: data })
}
